import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Introduction = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 3vw 0vw 0 0;
    text-align: center;
    z-index: inherit;
    justify-content: center;
    align-items: center;
    gap: 1vw;
    padding: 3vw 0;
    min-height: 30vh;

    /* #### Mobile Phones Portrait or Landscape #### */
    @media screen and (max-width: 766px){
        padding: 8vw 0;
    }

`;

export const LoginCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 3vw 3vw 3vw 3vw;

    max-width: 260px;
    text-align: center;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    gap: 0.75rem;
    margin-bottom: 10vw;

    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-10px);
    }

`;

export const SignUpCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 3vw 3vw 3vw 3vw;

    max-width: 260px;
    text-align: center;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    gap: 0.75rem;
    margin-bottom: 10vw;

    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-10px);
    }

`;